export default __webpack_public_path__ + "static/media/painting24.82dac9a1.jpeg";